module.exports = __webpack_public_path__ + "img/P4.783caebd.png";